<div class="user-action">
  <h1>Add User</h1>
  <div class="user-action__content">
    <form (submit)="onSubmit()" [formGroup]="userForm">
      <div class="user-action__row flex-wrap">
        <app-input-wrapper>
          <label>Name <span>*</span></label>
          <input
            type="text"
            formControlName="name"
            placeholder="Enter Name"
            inNoWhitespace
            maxlength="50"
            inOnlyAlphabets
          />
          <span
            *ngIf="userForm.get('name')?.errors?.['required']&&(userForm.get('name')?.dirty||userForm.get('name')?.touched)"
          >
            Name is required
          </span>
        </app-input-wrapper>

        <app-input-wrapper>
          <label>Email <span>*</span></label>
          <input
            type="text"
            formControlName="email"
            placeholder="Enter email"
            inNoWhitespace
          />
          <span
            *ngIf="userForm.get('email')?.errors?.['required']&&(userForm.get('email')?.dirty||userForm.get('email')?.touched)"
          >
            Email is required
          </span>
          <span
            *ngIf="!userForm.get('email')?.errors?.['required']&&userForm.get('email')?.errors?.['email']&&(userForm.get('email')?.dirty||userForm.get('email')?.touched)"
          >
            Invalid Email
          </span>
        </app-input-wrapper>

        <app-input-wrapper>
          <label>Phone No. <span>*</span></label>
          <input
            type="text"
            formControlName="phone"
            placeholder="Enter phone"
            inNoWhitespace
            mask="(000) 000-0000"
          />
          <span
            *ngIf="userForm.get('phone')?.errors?.['required']&&(userForm.get('phone')?.dirty||userForm.get('phone')?.touched)"
          >
            Phone No. is required
          </span>
          <span
            *ngIf="userForm.get('phone')?.errors?.['mask']&&(userForm.get('phone')?.dirty||userForm.get('phone')?.touched)"
          >
            Phone No. is invalid
          </span>
        </app-input-wrapper>

        <app-input-wrapper>
          <app-multiselect-dropdown
            [multiselect]="false"
            [searchable]="false"
            [pagination]="false"
            [config]="roleDropdownSettings"
            [options]="roles"
            [control]="userForm.get('role')"
            [error]="(userForm.get('role')?.errors?.['required']&&(userForm.get('role')?.dirty||userForm.get('role')?.touched))?'Author is required':''"
          ></app-multiselect-dropdown>
          <span
            *ngIf="userForm.get('role')?.errors?.['required']&&(userForm.get('role')?.dirty||userForm.get('role')?.touched)"
          >
            Role is required
          </span>
        </app-input-wrapper>
      </div>
      <div class="user-action__footer flex justify-end">
        <app-button
          customClass="outline"
          (action)="handleClose()"
          label="cancel"
        >
        </app-button>
        <app-button [isDisabled]="isLoading" type="submit" label="Submit">
          <app-button-loader
            *ngIf="isLoading"
            postfixContent
          ></app-button-loader>
        </app-button>
      </div>
    </form>
  </div>
</div>
